import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function acceptProposition(input: { enrollmentId: number; propositionId: number }) {
  const { enrollmentId, propositionId } = input
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.acceptProposition.url, { id: enrollmentId, propositionId })
    )
    .post()
}
